export const MODAL_MONITORING_INTERVAL_MS = 48 * 60 * 60 * 1000;
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const DURATION_MS = {
  ONE_SECOND: SECOND,
  ONE_MINUTE: MINUTE,
  FIVE_MINUTES: 5 * MINUTE,
  THIRTY_MINUTES: 30 * MINUTE,
  ONE_HOUR: HOUR,
  SIX_HOURS: 6 * HOUR,
  ONE_DAY: DAY,
  ONE_WEEK: 7 * DAY,
  TWO_WEEKS: 14 * DAY,
  THIRTY_DAYS: 30 * DAY,
};
